import { AbstractControl, ValidatorFn } from "@angular/forms";

export function MinMaxValidator(regex: RegExp): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = regex.test(control.value);
    return !value ? { minMax: true } : null;
  };
}

export function PasswordValidator(regex: RegExp): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = regex.test(control.value);
    return !value ? { password: true } : null;
  };
}
